import { Component, Input, Output, EventEmitter } from '@angular/core';

import { DvlSettingsService } from '../../../services/settings.service';

@Component({
  selector: 'dvl-food-picker',
  templateUrl: './food-picker.component.html'
})
export class DvlFoodPickerComponent {
  @Output('close') closeEmitter: EventEmitter<void>;
  @Output('select') selectEmitter: EventEmitter<any>;

  private foods: any[];
  private foodFocus: any;

  constructor(private settingsService: DvlSettingsService) {
    this.closeEmitter = new EventEmitter<void>();
    this.selectEmitter = new EventEmitter<any>();
    this.settingsService.foods$.subscribe((foods) => this.foods = foods.filter((food) => food.active));
  }

  close(): void {
    this.closeEmitter.emit();
  }

  confirm(food: any): void {
    this.selectEmitter.emit(food);
    this.close();
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/reception/components/food-picker/food-picker.component.ts